import { createFileRoute, useParams } from '@tanstack/react-router'

import { FaceEditScreen } from '@/components/growers/faces/face-edit-screen'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/agriculture/my-grower/$growerId_/faces/$faceId',
)({
    component: MyGrowerFaceEditRoutePage,
})

/** Thêm/sửa một khuôn mặt — surface HỘ TRỒNG. faceId = "new" là thêm mới. */
function MyGrowerFaceEditRoutePage() {
    const { growerId, faceId } = useParams({
        from: '/_app/_authed/_sidebar/agriculture/my-grower/$growerId_/faces/$faceId',
    })

    return (
        <FaceEditScreen
            growerId={growerId}
            scope="my"
            faceId={faceId === 'new' ? undefined : faceId}
        />
    )
}
